import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import logo from "../../assets/Logo.png";
import { generalHelpers } from "../../helpers";
import { routesConstants } from "../../constants";
import { ICONS } from "../../constants/icons.constants";
import Icons from "../../components/icons";
import { Button, Input } from "../../kaya";
import { userActions } from "../../actions";

import styles from "./ResetPassword.module.scss";

const ResetPassword = () => {
  const [searchParams, setSeararams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token") || "";
  const [password, setPassword] = React.useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [err, setErr] = React.useState({
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleEyeClick = () => {
    setShowPassword(!showPassword);
  };

  const handleConfirmEyeClick = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleResetPassword = async () => {
    const error = {
      password: generalHelpers.validatePassword(password),
      confirmPassword: generalHelpers.validateConfirmPassword(
        password,
        confirmPassword
      ),
    };
    if (!generalHelpers.isEmptyErrors(error)) {
      setErr(error);
      return;
    }
    setIsLoading(true);
    // write api call 2
    await userActions.resetPasswordAction({
      emailToken: token,
      password,
      rePassword: confirmPassword,
    });
    // if (data.success) {
    // }
    navigate(routesConstants.ROUTES.LOGIN);
    setIsLoading(false);
  };

  return (
    <div className={styles.ResetPassword}>
      <div className={styles.logo}>
        {/* <Icons type={ICONS.LOGO} /> */}
        <img src={logo} alt="logo" />
      </div>
      <div className={styles.box}>
        <p className={styles.desc}>Reset Password</p>
        <p className={styles.desc2}>Create a new secure password</p>

        <div className={styles.box1}>
          <Input
            type={showPassword ? "string" : "password"}
            placeholder="New Password"
            className={styles.input}
            width="100%"
            value={password}
            onChange={(e) => {
              // eslint-disable-next-line no-unused-expressions
              setPassword(e),
                setErr({
                  ...err,
                  password: "",
                });
            }}
            errors={err}
            id="password"
            onSuffixIconClick={handleEyeClick}
            suffixIcon={
              <Icons type={showPassword ? ICONS.EYE_OFF : ICONS.EYE_ON} />
            }
          />
          <Input
            type={showConfirmPassword ? "string" : "password"}
            placeholder="Confirm Password"
            className={styles.input1}
            width="100%"
            onChange={(e) => {
              // eslint-disable-next-line no-unused-expressions
              setConfirmPassword(e),
                setErr({
                  ...err,
                  confirmPassword: "",
                });
            }}
            errors={err}
            id="confirmPassword"
            onEnterClick={handleResetPassword}
            onSuffixIconClick={handleConfirmEyeClick}
            suffixIcon={
              <Icons type={showPassword ? ICONS.EYE_OFF : ICONS.EYE_ON} />
            }
          />
          <Button
            className={styles.btn}
            onClick={handleResetPassword}
            type="Primary"
            isLoading={isLoading}
          >
            Reset Password
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
